require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-astrada-bs-styletron-react.json") })
        }
      }, "path---package-astrada-bs-styletron-react");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-astrada-bs-styletron-react!./.cache/json/package-astrada-bs-styletron-react.json
// module id = 746
// module chunks = 231608221292675